export default "__VITE_ASSET__DmQ4Vkv8__"